/* @flow */
import React from 'react';

import ActivityNotesFieldColumn from 'payments/components/ActivityNotesFieldColumn.jsx';
import Glyph from 'components/Glyph.jsx';
import TableRowUserName from 'payments/components/TableRowUserName.jsx';
import Text from 'components/Text.jsx';
import 'payments/components/styles/ActivityTable.scss';
import 'payments/components/styles/ActivityResponsesTableRow.scss';
import ActivityRecipient, {
  RECIPIENT_PENDING,
  RECIPIENT_ATTENDING,
  RECIPIENT_MAYBE,
  RECIPIENT_DECLINED,
} from 'entities/ActivityRecipient';

import ConversationStarter from './ConversationStarter.jsx';

function getAttendanceText(value) {
  return {
    [RECIPIENT_ATTENDING]: 'Yes',
    [RECIPIENT_DECLINED]: 'No',
    [RECIPIENT_PENDING]: '',
    [RECIPIENT_MAYBE]: 'Maybe',
  }[value];
}

type Props = {
  recipient: ActivityRecipient,
  onNoteEdit: (recipient: ActivityRecipient, value: string) => void,
  displayPaidRow: boolean,
}

type State = {
  note: ?string,
  editNote: boolean,
}

export default class ActivityResponsesTableRow extends React.Component {
  props: Props;

  state: State = {
    note: this.props.recipient.getNote(),
    editNote: false,
  };

  handleNoteChange(value: string) {
    this.setState({ note: value });
  }

  handleEditNoteClick() {
    this.setState({ editNote: true });
  }

  handleNoteSave(value: string) {
    this.handleNoteChange(value);
    this.setState({ editNote: false });
    this.props.onNoteEdit(this.props.recipient, value);
  }

  render() {
    const { recipient } = this.props;
    const user = recipient.getUser();

    return (
      <tr className="ActivityTable-row ActivityResponsesTableRow" key={recipient.id}>
        <td>
          <TableRowUserName user={recipient.getUser()} />
        </td>
        <td className="ActivityTable-row-noteColumn">
          <ActivityNotesFieldColumn
            onClick={() => this.handleEditNoteClick()}
            onInputSave={(value) => this.handleNoteSave(value)}
            onChange={(value) => this.handleNoteChange(value)}
            initialValue={this.state.note}
            editMode={this.state.editNote}
          />
        </td>
        <td>
          <Text color={recipient.getAttendance() === RECIPIENT_PENDING ? 'thunder' : undefined}>
            {getAttendanceText(recipient.getAttendance()) || <span>-</span>}
          </Text>
        </td>
        <td>
          {this.props.displayPaidRow &&
            <span>
              {this.props.recipient.hasPaid() ?
                <Glyph name="check" size="medium" /> :
                <span>-</span>
              }
            </span>
          }
        </td>
        <td className="ActivityResponsesTableRow-action-column">
          {user && <ConversationStarter user={user} />}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/ActivityResponsesTableRow.jsx